import { hotList } from "@/mocks/home";

export default function HotList() {
  return (
    <section id="hot" className="w-full bg-foreground-950 py-12 text-background-100 md:py-16">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <div className="flex flex-col gap-3 border-b border-foreground-800 pb-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-accent-400">
              03 / UPDATE RANKING
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-[32px]">
              更新热榜，最近值得一看
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-6 text-background-300/80">
            按近期浏览与收藏热度排序，条目均标注体量与更新时间，先扫榜单再决定从哪条开始。
          </p>
        </div>

        <div className="mt-8 overflow-hidden rounded-lg border border-foreground-800">
          <div className="hidden grid-cols-12 gap-4 border-b border-foreground-800 bg-foreground-900 px-5 py-3 text-xs tracking-wide text-background-400 md:grid">
            <span className="col-span-1">序</span>
            <span className="col-span-6">资源条目</span>
            <span className="col-span-2">所属分区</span>
            <span className="col-span-2">体量 / 形式</span>
            <span className="col-span-1 text-right">热度</span>
          </div>

          <ul className="divide-y divide-foreground-800">
            {hotList.map((item) => (
              <li
                key={item.rank}
                className="group cursor-pointer transition hover:bg-foreground-900"
              >
                <div className="grid grid-cols-12 items-center gap-3 px-4 py-4 md:gap-4 md:px-5">
                  <span
                    className={`col-span-2 font-heading text-xl font-bold md:col-span-1 ${
                      item.rank <= 3 ? "text-accent-400" : "text-background-400"
                    }`}
                  >
                    {String(item.rank).padStart(2, "0")}
                  </span>

                  <div className="col-span-10 md:col-span-6">
                    <p className="text-sm font-medium text-background-50 transition group-hover:text-accent-300 md:text-base">
                      {item.title}
                    </p>
                    <p className="mt-1 text-xs text-background-400 md:hidden">
                      {item.category} · {item.updated}
                    </p>
                  </div>

                  <span className="col-span-6 hidden md:col-span-2 md:block">
                    <span className="rounded-full bg-foreground-800 px-2.5 py-1 text-[11px] text-background-200">
                      {item.category}
                    </span>
                  </span>

                  <span className="col-span-6 hidden text-sm text-background-300 md:col-span-2 md:block">
                    {item.size}
                  </span>

                  <span className="col-span-12 flex items-center gap-2 md:col-span-1 md:justify-end">
                    <i className="ri-fire-line text-primary-400" />
                    <span className="text-xs text-background-300">{item.hot}</span>
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}